var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"language",on:{"click":_vm.toggleLanguage}},[_c('svg-icon',{attrs:{"icon-name":"language"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }